module.exports = __webpack_public_path__ + "img/1318584938.4ab83498.jpg";